import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/enterpriseAlexaSkill/importer/enterpriseAlexaSkillImporterActions';

export default importerReducers(actions);
